export default defineNuxtRouteMiddleware((to) => {
  // Match `/<integer>/anything-else`
  const match = to.path.match(/^\/\d+(?:\/(.*))?$/)
  if (match) {
    return navigateTo(`/${match[1] || ''}`, { redirectCode: 301 })
  }
})
